/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from "react";
import { Navigate, useNavigate, Route, Routes, } from "react-router-dom";
import "./css/App.css";
import "./css/home.css";
import "./css/inventory.css";
import "./css/kds.css";
import "./css/paymentpopup.css";
import "./css/dailysummary.css";
import "./css/uploader.css";
import "./css/NavPages.css";
import UfFb from "./firebase/unsynced_files_firebase";
import TestLogin from "./TestLogin";
import Homepage from "./containers/Homepage";
import Page1 from "./containers/Page1";
import Page2 from "./containers/Page2";
import Page3 from "./containers/Page3";
import Page5 from "./containers/Page5";

import KdsSystem from "./containers/KdsSystem";
import SetupPage from "./containers/SetupPage";
import InventoryPage from "./containers/InventoryPage";
import UploadPage from "./containers/UploadPage";
import OrdersPage from "./containers/OrdersPage";
import OrdersReport from "./containers/navlinks-pages/reports/OrdersReport";
import Login from "./Login";
import DirectLogin from "./DirectLogin";
import Context from "./context/context";

import Users from "./containers/Users";
import running_order_firebase from "./firebase/running_order_firebase";
import CustomersReports from "./containers/navlinks-pages/reports/CustomersReports";
import ItemReports from "./containers/navlinks-pages/reports/ItemReports";
import FlushData from "./components/FlushData";
import TeamLogin from "./TeamLogin";
import VideoTPopup from "./components/VideoTPopup";
import OrderTaxReport from "./containers/navlinks-pages/reports/OrderTaxReport";
import ReadFirebaseDinein from "./firebase/handle_dinein_orders";
import ReadFirebaseMeal from "./firebase/handel_meal_orders";
import DropZone from "./components/DropZone";
import ProfitAndLoss from "./containers/navlinks-pages/reports/ProfitAndLoss";
import ReadFirebasePrints from "./firebase/handle_order_prints";
import { KotInvoicePrint } from "./components/PrintKot";
import { InvoicePrint } from "./components/Invoice";
import ReadFBLoginDevices from "./firebase/handle_loggedIn_device";
import UPIPayments from "./containers/navlinks-pages/reports/UPIPayments";

export const App = () => {

  const page = window.location.pathname;
  const context = useContext(Context);
  const {
    setForceRenderPage1,
    isBulkUploadOpen,
    setIsBulkUploadOpen,
    generateMenues,
    flushData,
    setFlushData,
    videoPopUp,
    setVideoPopUp,
    setForceRenderOrdersPage,
    payment_popup_save_btns_ref,
    putOrdersTimeout,
    toggleAlarm,
    unAuthPopup,
    upload_backup,
    new_order,
    new_kotOrder,
    addItemToCart,
    showWarning,
    getAndUpdateUnsyncCount,

    PrintKotInvoice,
    kotPrintDependencies,
    kotPrintElemRef,
    invoicePrintElemRef,
    invoicePrintDependencies,

    calculateOrderValues
  } = context;

  const [loginState, setLoginState] = useState(null);
  const token = sessionStorage.getItem("token");
  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || [];
  const navigate = useNavigate();

  useEffect(() => +sessionStorage.getItem("tutorial") === 1 && setTimeout(() => setVideoPopUp(true), 5000), []);
  const keyDownListner = (event) => {
    const keyName = event.key;
    const page = window.location.pathname;

    if (
      event.ctrlKey &&
      keyName === "End" &&
      sessionStorage.getItem("popup-state") !== "true" &&
      document.getElementById("payment-btn")
    )
      document.getElementById("payment-btn").click();

    if (localStorage.getItem("preventKeyboard") === "true") return null;

    if (event.shiftKey) {
      if (page.includes("/page2")) {
        if (keyName === "S") document.getElementById("save-btn").click();
        else if (keyName === "K")
          document.getElementById("save&kot-btn").click();
        else if (keyName === "D") navigate(-1);
        else if (keyName === "W")
          document.getElementById("save-payment-btn").click();
        else if (keyName === "Q")
          document.getElementById("save&kot-payment-btn").click();
      }
    }

    if (sessionStorage.getItem("popup-state") === "true") {
      if (keyName === "Enter") {
        return document.querySelector(".popup-done").click();
      } else if (keyName === "Escape") {
        return document.querySelector(".popup-cancel").click();
      }

      let currentItem = document.querySelector(".popup-item-highlight");

      if (!currentItem)
        return document
          .querySelector(`[popup-index="0"]`)
          .classList.add("popup-item-highlight");

      const nextItem = document.querySelector(
        `[popup-index="${+currentItem?.getAttribute("popup-index") + 1}"]`
      );
      const prevItem = document.querySelector(
        `[popup-index="${+currentItem?.getAttribute("popup-index") - 1}"]`
      );

      if (keyName === "ArrowDown") {
        currentItem.classList.remove("popup-item-highlight");
        if (!nextItem) {
          document
            .querySelector(`[popup-index="0"]`)
            .classList.add("popup-item-highlight");
          return document
            .querySelector(`[popup-index="0"]`)
            .scrollIntoViewIfNeeded(true);
        }

        nextItem.classList.add("popup-item-highlight");
        nextItem.scrollIntoViewIfNeeded(true);
      } else if (keyName === "ArrowUp") {
        if (!prevItem) return;
        currentItem.classList.remove("popup-item-highlight");
        prevItem.classList.add("popup-item-highlight");
        prevItem.scrollIntoViewIfNeeded(true);
      } else if (keyName === "+") {
        const currentItemIndex = currentItem?.getAttribute("popup-index");
        currentItem.click();
        setTimeout(() => {
          document
            .querySelector(`[popup-index="${+currentItemIndex}"]`)
            .classList.add("popup-item-highlight");
        }, 100);
      }
      return;
    } else if (sessionStorage.getItem("is-payment-popup") === "true") {
      let currentField = document.querySelector(".amount-field.selected");
      if (!currentField) return console.log("no current field found");

      let nextField = document.querySelector(
        `[payment-field-index="${+currentField?.getAttribute("payment-field-index") + 1
        }"]`
      );
      let prevField = document.querySelector(
        `[payment-field-index="${+currentField?.getAttribute("payment-field-index") - 1
        }"]`
      );

      if (keyName === "ArrowDown") {
        currentField.classList.remove("selected");
        currentField.blur();

        if (nextField) {
          nextField.classList.add("selected");
          nextField.focus();
        } else {
          document
            .querySelector('[payment-field-index="0"]')
            .classList.add("selected");
          document.querySelector('[payment-field-index="0"]').focus();
        }
      } else if (keyName === "ArrowUp") {
        if (prevField) {
          currentField.classList.remove("selected");
          currentField.blur();
          prevField.classList.add("selected");
          prevField.focus();
        }
      } else if (keyName === "Escape") {
        document.querySelector("#payment-cancel-btn").click();
      } else if (event.ctrlKey && keyName === "End") {
        // payment_popup_save_btns_ref.current.click()
        payment_popup_save_btns_ref.current
          .querySelector("#save-and-payment-btn")
          .click();
      } else if (keyName === "e") {
        if (!document.querySelector(".invoice-container.payment-popup.active"))
          return;
        payment_popup_save_btns_ref.current
          .querySelector("#payment-invoice-container")
          .querySelector("#payment-popup-invoice-ebill")
          .click();
      } else if (keyName === "0") {
        if (!document.querySelector(".invoice-container.payment-popup.active"))
          return;
        payment_popup_save_btns_ref.current
          .querySelector("#payment-invoice-container")
          .querySelector("#payment-popup-invoice-0")
          .click();
      } else if (keyName === "1") {
        if (!document.querySelector(".invoice-container.payment-popup.active"))
          return;
        payment_popup_save_btns_ref.current
          .querySelector("#payment-invoice-container")
          .querySelector("#payment-popup-invoice-1")
          .click();
      } else if (keyName === "2") {
        if (!document.querySelector(".invoice-container.payment-popup.active"))
          return;
        payment_popup_save_btns_ref.current
          .querySelector("#payment-invoice-container")
          .querySelector("#payment-popup-invoice-2")
          .click();
      }

      return;
    } else {
      if (sessionStorage.getItem("is-payment-popup")?.toString() === "true")
        return;
      if (sessionStorage.getItem("popup-state")?.toString() === "true") return;

      let selectedElementIndex;
      let selectedElement;
      let className;

      if (page.includes("/page1")) className = "seatSearchTarget";
      else if (page.includes("/page2")) className = "itemDiv";
      else if (window.location.pathname === "/orders")
        className = "order-card-div";

      Array.from(document.getElementsByClassName(className)).forEach((div) => {
        if (div.querySelector("button").classList.contains("highlighted-card")) {
          selectedElement = div;
          selectedElementIndex = div?.getAttribute("index");
        }
      });

      const nextElement = document.querySelector(
        `[index="${+selectedElementIndex + 1}"]`
      );
      const prevElement = document.querySelector(
        `[index="${+selectedElementIndex - 1}"]`
      );
      const selectedElement_sectionIndex =
        +selectedElement?.getAttribute("section-index");

      let indexesObj;

      if (page.includes("/page1"))
        indexesObj =
          JSON.parse(sessionStorage.getItem("seats-indexesObj")) || {};
      else if (page.includes("/page2"))
        indexesObj =
          JSON.parse(sessionStorage.getItem("menu-indexesObj")) || {};
      else if (page === "/orders")
        indexesObj =
          JSON.parse(sessionStorage.getItem("orders-indexesObj")) || {};

      let selected_section_item_index = selectedElement_sectionIndex
        ? indexesObj[`${selectedElement_sectionIndex}`]
        : "";
      let next_section_item_index = selectedElement_sectionIndex
        ? indexesObj[`${selectedElement_sectionIndex + 1}`]
        : "";
      let prev_section_item_index = selectedElement_sectionIndex
        ? indexesObj[`${selectedElement_sectionIndex - 1}`]
        : "";

      let sectionFirstIndex = document
        .querySelector(
          `[this-section-index="${+selectedElement?.getAttribute(
            "section-index"
          )}"]`
        )
        ?.firstElementChild?.getAttribute("index");

      let sectionLastIndex = document
        .querySelector(
          `[this-section-index="${+selectedElement?.getAttribute(
            "section-index"
          )}"]`
        )
        ?.lastElementChild?.getAttribute("index");

      if (keyName === "ArrowLeft") {
        if (prevElement) {
          if (+selectedElementIndex - 1 < +sectionFirstIndex)
            indexesObj[`${selectedElement_sectionIndex - 1}`] =
              +selectedElementIndex - 1;
          else
            indexesObj[`${selectedElement_sectionIndex}`] =
              +selectedElementIndex - 1;

          if (page.includes("/page1"))
            sessionStorage.setItem(
              "seats-indexesObj",
              JSON.stringify(indexesObj)
            );
          else if (page.includes("/page2"))
            sessionStorage.setItem(
              "menu-indexesObj",
              JSON.stringify(indexesObj)
            );
          else if (page === "/orders")
            sessionStorage.setItem(
              "orders-indexesObj",
              JSON.stringify(indexesObj)
            );

          prevElement.click();
          prevElement.scrollIntoViewIfNeeded();
        }
      } else if (keyName === "ArrowRight") {
        document
          .querySelector(`[index="${+selectedElementIndex}"]`)
          .classList.remove("selected-in-section");
        if (nextElement) {
          if (+selectedElementIndex + 1 > +sectionLastIndex)
            indexesObj[`${selectedElement_sectionIndex + 1}`] =
              +selectedElementIndex + 1;
          else
            indexesObj[`${selectedElement_sectionIndex}`] =
              +selectedElementIndex + 1;

          if (page.includes("/page1"))
            sessionStorage.setItem(
              "seats-indexesObj",
              JSON.stringify(indexesObj)
            );
          else if (page.includes("/page2"))
            sessionStorage.setItem(
              "menu-indexesObj",
              JSON.stringify(indexesObj)
            );
          else if (page === "/orders")
            sessionStorage.setItem(
              "orders-indexesObj",
              JSON.stringify(indexesObj)
            );

          nextElement.scrollIntoViewIfNeeded();
          nextElement.click();
        } else {
          indexesObj[selected_section_item_index] = +selectedElementIndex + 1;
          sessionStorage.setItem("indexesObj", JSON.stringify(indexesObj));
          document
            .querySelector(`[index="0"]`)
            .classList.add("selected-in-section");
          document.querySelector(`[index="0"]`).scrollIntoViewIfNeeded();
          return document.querySelector(`[index="0"]`).click();
        }
      } else if (keyName === "ArrowDown") {
        const nextSectionItem = next_section_item_index
          ? document.querySelector(`[index="${+next_section_item_index}"]`)
          : document.querySelector(
            `[section-index="${+selectedElement_sectionIndex + 1}"]`
          );
        if (nextSectionItem) {
          nextSectionItem.scrollIntoViewIfNeeded();
          nextSectionItem.click();
        }
      } else if (keyName === "ArrowUp") {
        const prevSectionItem = prev_section_item_index
          ? document.querySelector(`[index="${+prev_section_item_index}"]`)
          : document.querySelector(
            `[section-index="${+selectedElement_sectionIndex - 1}"]`
          );
        if (prevSectionItem) {
          prevSectionItem.scrollIntoViewIfNeeded();
          prevSectionItem.click();
        }
      } else if (keyName === "Enter") {
        if (selectedElement) {
          if (page.includes("/page1")) {
            selectedElement.querySelector(".dblClickTrigger").click();
          } else if (page.includes("/page2")) {
            selectedElement.querySelector(".click-handler-element").click();
          } else if (window.location.pathname === "/orders") {
            selectedElement.querySelector(".order-click-handler").click();
          }
        } else return;
      } else if (keyName === "-" || keyName === "Delete") {
        if (!page.includes("/page2") || !selectedElement) return;
        const uuid = selectedElement?.getAttribute("item-uuid");

        const targetSvg = document.getElementById(`${uuid}-minus-ico`);
        targetSvg && document.getElementById(`${uuid}-minus-ico`).click();
      } else if (keyName === "+") {
        if (!page.includes("/page2") || !selectedElement) return;
        const uuid = selectedElement?.getAttribute("item-uuid");

        document.getElementById(`${uuid}-plus-ico`) &&
          document.getElementById(`${uuid}-plus-ico`).click();
      }
    }
  }

  // Keyboard
  useEffect(() => {
    document.addEventListener("keydown", keyDownListner);
    return () => document.removeEventListener("keydown", keyDownListner);
  }, []);

  const initiateTimers = () => {
    if (
      !(
        page.includes("/login") ||
        page.includes("/reg-website") ||
        page.includes("/reg-yth1") ||
        page.includes("/reg-yte2") ||
        page.includes("/reg-yt3") ||
        page.includes("/reg-yt4") ||
        page.includes("/reg-yt5") ||
        page.includes("/reg-team")
      ) &&
      localStorage.getItem("outlet_uuid")?.length > 1 &&
      +localStorage.getItem("refresh_status") === 0
    ) {

      const user_type = +localStorage.getItem('user_type');
      function setFirabaseCallbacks() {
        JSON.parse(sessionStorage.getItem("syncing_timers"))?.forEach((id) => clearInterval(id));
        sessionStorage.removeItem("syncing_timers");
        sessionStorage.removeItem("_FIREBASE_CALLBACKS_SET");

        running_order_firebase.ReadValueFromFirebase(
          localStorage.getItem("outlet_uuid"),
          { setForceRenderOrdersPage, toggleAlarm, setForceRenderPage1, calculateOrderValues }
        );

        UfFb.ReadValueFromFirebase(
          localStorage.getItem("outlet_uuid"),
          setForceRenderOrdersPage,
          setForceRenderPage1,
          generateMenues,
          getAndUpdateUnsyncCount
        );

        ReadFBLoginDevices({
          logout: () => {
            sessionStorage.clear()
            localStorage.setItem("Simple_logout", "0");
            window.location.pathname = "/login";
          }
        })

        if (+user_type === 1) {
          ReadFirebasePrints({ PrintKotInvoice });
          ReadFirebaseMeal();

          getAndUpdateUnsyncCount();
          putOrdersTimeout();

          let order_requests = JSON.parse(localStorage.getItem("order_requests"));
          sessionStorage.removeItem("alarm-interval-id");

          if (Array.isArray(order_requests) && order_requests.length > 0) {
            toggleAlarm(true);
          }
        }

        console.log('Firebase callbacks + syncing timers set')
      }

      window.ononline = () => {
        showWarning({
          message: 'Internet Connection Restored',
          classname: 'active-green'
        })

        setFirabaseCallbacks()
      }

      window.onoffline = () => {
        showWarning({
          // message: 'Internet Disconnected!!, data syncing will continue after connection restores.',
          message: 'Disconnected from the Internet, Data backup and Syncing might get affected !!',
          classname: 'active-red',
          time: 5000
        })

        JSON.parse(sessionStorage.getItem("syncing_timers"))?.forEach(id => clearInterval(id));
        sessionStorage.removeItem("syncing_timers")
      }

      if (!window.navigator.onLine) return console.warn('Network offline')
      else setFirabaseCallbacks()
    }
  };

  useEffect(() => {
    if (
      (!token || localStorage.getItem("Simple_logout") === "0") &&
      !(
        page.includes("/login") ||
        page.includes("/reg-website") ||
        page.includes("/reg-yth1") ||
        page.includes("/reg-yte2") ||
        page.includes("/reg-yt3") ||
        page.includes("/reg-yt4") ||
        page.includes("/reg-yt5") ||
        page.includes("/ssu-outlet-login") ||
        page.includes("/reg-team")
      )
    ) {
      let COUNTS = +localStorage.getItem('_WINDOWS_COUNTS_')
      localStorage.setItem('_WINDOWS_COUNTS_', ++COUNTS)
      return (window.location.pathname = "/login");
    }

    if (
      token &&
      !sessionStorage.getItem("generated-collection") &&
      +localStorage.getItem("refresh_status") === 0
    )
      generateMenues();
  });

  const backupTimeoutRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem('BYPASS')?.includes('SYNC')) return
    if (!page.includes("/login") && !backupTimeoutRef?.current) {

      backupTimeoutRef.current = setInterval(() => {
        upload_backup();
      }, 3600000);

      ReadFirebaseDinein(
        new_order,
        new_kotOrder,
        addItemToCart,
        setForceRenderPage1,
        PrintKotInvoice
      );

      initiateTimers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState]);

  if (!page.includes('login') && !page.includes('/kds') && +localStorage.getItem('user_type') === 3 && sessionStorage.getItem('token')) {
    window.location.pathname = '/kds'
    return <></>
  }
  else
    return (
      <div className="App">
        <Routes>
          <Route path="/reg-website" element={<TestLogin />} />
          <Route path="/reg-yth1" element={<TestLogin />} />
          <Route path="/reg-yte2" element={<TestLogin />} />
          <Route path="/reg-yt3" element={<TestLogin />} />
          <Route path="/reg-yt4" element={<TestLogin />} />
          <Route path="/reg-yt5" element={<TestLogin />} />
          <Route path="/reg-team" element={<TeamLogin />} />
          <Route path="/page1/*" element={<Page1 />} />
          <Route path="/page2/:order_type/:order_uuid" element={<Page2 />} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/page4" element={<Homepage />} />
          <Route path="/profit_lose_estimate" element={<ProfitAndLoss />} />
          <Route path="/kds/*" element={<KdsSystem />} />

          {+restrictions[0]?.other_menu_and_seat_open_menu_and_edit === 0 ? ("")
            : (<Route path="/page4/:bId/:menuId" element={<Homepage />} />)
          }
          <Route path="/mealMenu/:bId/:menuId" element={<Homepage />} />
          {+restrictions[0]?.other_users === 0 ? ("") : (
            <Route path="/Users" element={<Users />} />
          )}
          {+restrictions[0]?.other_menu_and_seat === 0 ? ("") : (
            <Route path="/page5" element={<Page5 />} />
          )}
          {+restrictions[0]?.other_setup_page_setup === 0 ? ("") : (
            <Route path="/setup" element={<SetupPage />} />
          )}
          {+restrictions[0]?.other_report_customer === 0 ? ("") : (
            <Route path="/report-Customers" element={<CustomersReports />} />
          )}

          <Route path="/report-items" element={<ItemReports />} />
          <Route path="/report-Order-tex" element={<OrderTaxReport />} />
          <Route path="/report-orders" element={<OrdersReport />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/upi_payments" element={<UPIPayments />} />
          <Route path="/Inv-Ac" element={<InventoryPage />} />
          <Route path="/Inv-Ac/Voucher-Stock-Transfer" element={<InventoryPage />} />
          <Route path="/ssu-outlet-login/:userId/:outletId" element={<DirectLogin />} />
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login setLoginState={setLoginState} />} />
        </Routes>

        {/* Notifications */}
        <div className={`copies_notification ${unAuthPopup ? "copies_notification_active" : ""}`} style={{ backgroundColor: "red", zIndex: "999999" }}>Unauthorized Access !!</div>
        <div className="notification-container"><p className="notification-message"></p></div>
        <div className="notification-container permission">
          <p className="notification-message">SOME MESSAGE</p>
          <button>Allow</button>
        </div>

        {flushData ? <FlushData onClose={() => setFlushData(false)} /> : ""}
        {videoPopUp ? (<VideoTPopup close={() => { setVideoPopUp(false); sessionStorage.setItem("tutorial", 0); }} />) : ("")}
        {isBulkUploadOpen && (<DropZone close={() => { setIsBulkUploadOpen(false); }} setIsBulkUploadOpen={setIsBulkUploadOpen} />)}

        {/* Invoices */}
        <div id='print-component-wrapper' style={{ display: 'none' }}>
          <div ref={kotPrintElemRef} id='kot-invoice-print'><KotInvoicePrint dependencies={kotPrintDependencies} /></div>
          <div ref={invoicePrintElemRef} id='invoice-print'><InvoicePrint dependencies={invoicePrintDependencies} /></div>
        </div>
      </div>
    );
};

export default App;